import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { teamApi } from '../../services/api';
import TeamForm from '../../components/teams/TeamForm';
import { AlertTriangle, Shield, ArrowLeft } from 'lucide-react';

const CreateTeamPage = () => {
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (teamData) => {
    setIsSaving(true);
    setError(null);
    try {
      await teamApi.createTeam(teamData);
      navigate('/teams');
    } catch (err) {
      setError('Failed to create team. Please try again.');
      console.error(err);
      setIsSaving(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 via-blue-950 to-slate-800">

      {/* Dark hero header */}
      <div className="bg-gradient-to-r from-gray-900 via-blue-950 to-gray-900 border-b-4 border-yellow-400">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <button
            onClick={() => navigate('/teams')}
            className="inline-flex items-center gap-2 text-gray-400 hover:text-white text-sm font-medium mb-5 transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />Back to My Teams
          </button>
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-2xl bg-yellow-400 flex items-center justify-center shadow-lg shrink-0">
              <Shield className="h-6 w-6 text-gray-900" />
            </div>
            <div>
              <span className="text-xs font-bold text-yellow-400 uppercase tracking-widest">Teams</span>
              <h1 className="text-2xl sm:text-3xl font-black text-white tracking-tight">Create New Team</h1>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {error && (
          <div className="bg-red-900/30 border border-red-500/30 rounded-2xl p-4 flex items-center gap-3 text-red-400 mb-6">
            <AlertTriangle className="h-5 w-5 shrink-0" />
            <span className="text-sm font-medium">{error}</span>
          </div>
        )}
        <TeamForm onSubmit={handleSubmit} isSaving={isSaving} />
      </div>
    </div>
  );
};

export default CreateTeamPage;
